import styled from 'styled-components';

export const ToggleSwitchSliderBox = styled.span<{checked: boolean}>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => (props.checked ? props.theme.colors.brandPrimary : '#ccc')};
  transition: background-color 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: transform 0.4s;
    border-radius: 50%;
    transform: ${props => (props.checked ? 'translateX(20px)' : 'translateX(0)')};
  }
`;